import React, { Fragment } from "react";
import { parseMarkup } from "./rasputinMarkup";
import styles from "./RasputinText.module.scss";

// Renders backend or merchant text that may contain simple markup. Use instead of dangerouslySetInnerHTML.
// dropUnknownTags removes tags outside the allowlist instead of showing them as text.
export default function RasputinText({ text, dropUnknownTags = false }) {
    if (!text) return null;

    return <>{parseMarkup(text, { dropUnknownTags }).map(renderNode)}</>;
}

function renderNode(node, index) {
    if (node.kind === "text") {
        return <Fragment key={index}>{node.text}</Fragment>;
    }

    const children = node.children.map(renderNode);

    switch (node.tag) {
        case "br":
            return <br key={index} />;
        case "a":
            return node.href ? (
                <a key={index} href={node.href} target={node.newTab ? "_blank" : undefined} rel={node.newTab ? "noreferrer" : undefined}>
                    {children}
                </a>
            ) : (
                <Fragment key={index}>{children}</Fragment>
            );
        case "span":
            return node.variant ? (
                <span key={index} className={styles[node.variant]}>
                    {children}
                </span>
            ) : (
                <Fragment key={index}>{children}</Fragment>
            );
        default: {
            const Tag = node.tag;
            return <Tag key={index}>{children}</Tag>;
        }
    }
}
